import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MfTimeTrackingComponent } from './mf-time-tracking.component';

const routes: Routes = [
  {
    path: '',
    component: MfTimeTrackingComponent,
    children: [
      {
        path: '**',
        component: MfTimeTrackingComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MfTimeTrackingRoutingModule {}
